/*
  Laedt die Karte erst auf Klick.

  Eine fest eingebundene Google-Karte laedt beim Oeffnen der Seite Daten
  von Google und setzt dabei Cookies - also bevor der Besucher im
  Cookie-Banner zugestimmt hat. Mit dem Klick entscheidet er selbst.
*/
class HssKarte extends HTMLElement {
  connectedCallback() {
    var knopf = this.querySelector('button');
    if (!knopf) return;
    var self = this;
    knopf.addEventListener('click', function () {
      var url = self.dataset.url;
      if (!url) return;
      var rahmen = document.createElement('iframe');
      rahmen.src = url;
      rahmen.loading = 'lazy';
      rahmen.title = 'Karte';
      rahmen.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      rahmen.setAttribute('allowfullscreen', '');
      self.innerHTML = '';
      self.appendChild(rahmen);
    });
  }
}
if (!customElements.get('hss-karte')) customElements.define('hss-karte', HssKarte);
